import './App.css';
import { useEffect, useState } from "react";
import RulesAcceptance from './components/Rules';
import Spinner from './components/Spinner';

const configBaseUrl = `https://d2mnf69gt2tvvs.cloudfront.net`


function App() {
  const [data, setData] = useState({ organizationData: {}, keyData: {}, config: {}, rulesData: [], isLoading: true, rulesOpen: false, localRulesAccepted: false });
  function handleRulesLink() {
    setData(prev => (({
      ...prev,
      rulesOpen: true
    })))
  }

  async function onAccepted(name) {
    const searchParams = new URLSearchParams(window.location.search);
    const keyId = searchParams.get('keyId');
    const organizationId = searchParams.get('organizationId');
    const params = {
      "visitor_accept_rules_name": name
    }
    const env = searchParams.get('env')
    let apiUrl = ""
    if (env === "dev") {
      apiUrl = "https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev"
    } else {
      apiUrl = "https://74ow2locr0.execute-api.us-east-2.amazonaws.com/prod"
    }
    setData(prev => ({
      ...prev,
      isLoading: true
    }))

    const response = await fetch(
      `${apiUrl}/${organizationId}/keys/${keyId}/acceptRules`,
      {
        method: `POST`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: JSON.stringify(params)
      }
    )
    if (response.status === 200) {
      const data = await response.json();
      console.log('Success:', data);
      const jointData = await fetchDataFromQueryStringParams();
      setData(prev => ({
        ...prev,
        ...jointData,
        rulesOpen: false,
        isLoading: false,
        isError: false
      }));
    } else {
      console.log('Request failed with status:', response.status);
      // TODO show error message
      setData(prev => (({
        ...prev,
        rulesOpen: false,
        isLoading: false,
      })))
    }
  }

  function closeModal() {
    setData(prev => (({
      ...prev,
      rulesOpen: false
    })))
  }

  useEffect(() => {
    async function loadData() {
      try {
        setData(prev => ({
          ...prev,
          isLoading: true,
          isError: false
        }));
        const configData = await fetchConfig();
        const jointData = await fetchDataFromQueryStringParams();

        setData({
          ...jointData,
          config: configData,
          isLoading: false,
          isError: false
        });

      } catch (err) {
        console.error(err);

        setData(prev => ({
          ...prev,
          isLoading: false,
          isError: true
        }));
      }
    }
    loadData();
  }, []); // empty array → run once on mount
  if (data.isLoading) {
    return (
      <div className="App">
        <div className='App-header'>
          <Spinner />
          <p>Loading</p>
        </div>
      </div>
    );
  } else if (data.isError) {
    return (<div className="App">
      <div className='App-header'>
        <p>There was an error loading your key.</p>
        <p>Please try again later.</p>
      </div>
      <footer className="App-footer">
        <div className='supplemental'>
          <a href="https://www.communitytech.io/privacy-policy">Privacy Policy</a>
          <a href="https://www.communitytech.io/terms-of-service">Terms of Service</a>
        </div>
        <h4 className='poweredBy'>Powered by Community Tech</h4>
      </footer>
    </div>)
  }
  let organizationLogoUrl = data.organizationData.organization_logo_url
  let organizationName = data.organizationData.organization_name
  let organizationPhone = data.organizationData.organization_phone
  let organizationEmail = data.organizationData.organization_email
  let organizationAddress = `${data.organizationData.organization_address} ${data.organizationData.organization_address_2} ${data.organizationData.organization_city} ${data.organizationData.organization_state},  ${data.organizationData.organization_zip}`
  let visitorName = `${data.keyData.visitor_first_name} ${data.keyData.visitor_last_name}`
  let keyType = `${data.keyData.key_type}`
  let activeTime = new Date(data.keyData.time_active)
  let expiration = new Date(data.keyData.expiration_time)
  let activeString = activeTime.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  let expirationString = expiration.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  let residentAddress = `${data.unitData?.unit_full_address ?? ""}`
  let residentPhone = `${data.residentData.primary_phone_number}`
  let residentName = `${data.residentData.first_name} ${data.residentData.last_name}`

  let keyId = data.keyData.key_id
  let qrCodeApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${keyId}`
  return (
    <div className="App">
      <header className="App-header">
        {data.rulesOpen && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background:
                "rgba(0,0,0,0.65)",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "scroll",

              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: "95%",
                maxHeight: "80vh",
                overflow: "hidden",
                background: "white",
                borderRadius: 12,
                paddingTop: 24,
                paddingBottom: 24,
                boxShadow:
                  "0 10px 40px rgba(0,0,0,0.3)",
                alignItems: "center",
                justifyContent: "center",
                display: 'flex'
              }}
            >
              <RulesAcceptance
                pdfs={data.rulesData.keys.map(item => ({
                  id: item,
                  url: `${configBaseUrl}/${item}`
                }))}
                onAccepted={(signature) => {
                  onAccepted(signature)
                }}
                closeModal={() => closeModal()}
              />
            </div>
          </div>
        )}

        {
          organizationLogoUrl ?
            <img src={organizationLogoUrl} className="communityImage" alt="logo" />
            :
            null

        }
        <br />
        <b className='visitorInformation'>Welcome to {organizationName}, {visitorName}</b>

        <div className='rulesContainer'>
          <b className='visitorInformation'>Please review the rules below prior to arriving. Rules are strictly enforced.</b>
          <button className="rules" onClick={() => handleRulesLink()}>Link to Rules</button>
        </div>
        {
          (data.keyData.rules_accepted) === 0 ?
            <div>
              Accept the above rules to view your access key
            </div>
            :
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <img src={qrCodeApiUrl} className="qr-code" alt="logo" />
              <b>{keyId}</b>
            </div>
        }

        <br />
        <b className='visitorInformation'>
          Please have your ID ready to show at the gate.
          {
            data.config.additionalInstructions && (
              <div>
                <br />
                {data.config.additionalInstructions}
              </div>
            )
          }
        </b>

        <div className='keyInfo'>
          <p>{keyType} Key</p>
          <p>Valid: {activeString} - {expirationString}</p>
        </div>


        <button className="direction" onClick={() => handleMapsDeeplink(organizationAddress)}>Directions to Gate</button>
        {
          data.config.showDirectionsButton && data.unitData && (
            <button className="direction" onClick={() => handleMapsDeeplink(residentAddress)}>{data.config.directionsToUnitText ?? "Directions to Unit"}</button>
          )
        }
        {
          data.config.showContactButton && (
            <button className="contact" onClick={() => initiateCall(residentPhone)}>Contact {residentName}</button>
          )
        }

      </header >
      <footer className="App-footer">
        <div className='communityContact'>
          <p>Contact Phone Number: {organizationPhone}</p>
          <p>Email: {organizationEmail}</p>
          <p><a href='https://communitytech.io'>communitytech.io</a></p>
        </div>
        <div className='supplemental'>
          <a href="https://www.communitytech.io/privacy-policy">Privacy Policy</a>
          <a href="https://www.communitytech.io/terms-of-service">Terms of Service</a>
        </div>
        <h4 className='poweredBy'>Powered by Community Tech</h4>
      </footer>
    </div >
  );
}

async function fetchConfig() {
  const searchParams = new URLSearchParams(window.location.search);
  const organizationId = searchParams.get('organizationId');
  let configResult = await fetch(`${configBaseUrl}/communities/${organizationId}/config/keyPage/config.json`)
  let configData = await configResult.json()
  console.log("Config Result", configData)
  return configData
}


async function fetchDataFromQueryStringParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const env = searchParams.get('env')
  let apiUrl = ""
  if (env === "dev") {
    apiUrl = "https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev"
  } else {
    apiUrl = "https://74ow2locr0.execute-api.us-east-2.amazonaws.com/prod"
  }

  const keyId = searchParams.get('keyId');
  const organizationId = searchParams.get('organizationId');
  let keyPageDataResponse = await fetch(`${apiUrl}/${organizationId}/keys/${keyId}/keyPage`)
  let keyPageData = await keyPageDataResponse.json()


  return {
    organizationData: keyPageData.data.payload.organizationData,
    keyData: keyPageData.data.payload.keyData,
    residentData: keyPageData.data.payload.userData,
    unitData: keyPageData.data.payload.unitData,
    rulesData: keyPageData.data.rulesData
  }
}

// const isAndroid = () => {
//   return /Android/i.test(navigator.userAgent);
// };

const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function handleMapsDeeplink(address) {
  let mapsUrl = ""
  if (isIOS()) {
    mapsUrl = "https://maps.apple.com/search?query=" + address
  } else {
    mapsUrl = "https://maps.google.com/?q=" + address
  }
  window.location = mapsUrl
}

function initiateCall(phoneNumber) {
  window.location.href = "tel:" + phoneNumber

}



export default App;
